import { gbToBytes } from "./conversionUtils";

interface IProps {
  total: number | undefined;
  projected: number | undefined;
  limit: number | undefined;
}

export const getBandwidthUsageState = ({ limit, total, projected }: IProps) => {
  limit = limit ?? 0;
  projected = projected ?? 0;
  total = total ?? 0;
  const limitBytes = gbToBytes(limit ?? 0);

  if (limit === 0) return;

  if (total / limitBytes >= 0.99) return "error";

  if (projected > limitBytes && total > 0.5 * limitBytes) return "warning";

  return;
};
